import Reveal from "./Reveal";

export default function SectionHeading({ eyebrow, title, note, noteColor = "text-current" }) {
  return (
    <Reveal className="mb-14 md:mb-20">
      <p className="font-mono text-[11px] tracking-[0.3em] uppercase opacity-60 mb-5">{eyebrow}</p>
      <h2 className="font-display font-black uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-6xl">
        {title}
      </h2>
      {note && (
        <p className={`font-hand text-2xl md:text-3xl mt-4 -rotate-1 inline-block ${noteColor}`}>{note}</p>
      )}
    </Reveal>
  );
}
